import React, { useEffect } from "react";
import { Grid, Box, Typography, Paper, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import PrintData from "../../../components/common/section/printData";

const StepCard = styled(Paper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "261px",
  height: "180px",
  border: "1px solid #E3E3E3",
  borderRadius: "12px",
  position: "relative",
  overflow: "hidden",
  boxSizing: "border-box",
}));

const StepNumberBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%",
  height: "40px",
  background: "linear-gradient(90deg, #1874D2 0%, #05172A 100%)",
  boxShadow: "0px 4px 8px -6px rgba(19, 16, 34, 0.04)",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingLeft: theme.spacing(2),
}));

const StepNumber = styled(Typography)(({ theme }) => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "32px",
  lineHeight: "80px",
  color: "#EEC044",
}));

const StepDescription = styled(Typography)(({ theme }) => ({
  position: "absolute",
  top: "0",
  left: "0",
  right: "0",
  bottom: "35px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#878680",
  textAlign: "left",
  padding: theme.spacing(2),
  wordWrap: "break-word",
}));

const ViewSubsectionSteps = ({
  fetchContentData,
  subsection,
  section,
  language,
}) => {
  const [content, setContent] = React.useState([]);
  const theme = useTheme();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchContentData({
          subsection: subsection.subsection,
          section,
          language,
        });
        setContent(response.data);
      } catch (error) {
        console.error("Error fetching content data:", error);
      }
    };
    fetchData();
  }, [subsection, section, language]);

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "white",
          padding: "10px",
          paddingBottom: "30px",
        }}
      >
        <PrintData fileName={`${subsection.subsection}.pdf`} />
      </Box>
      <Box
        sx={{
          margin: "0 auto",
          padding: theme.spacing(2),
          gap: 2,
          maxWidth: "100vw",
          borderBottom: "2px solid #D3D3D3",
        }}
      >
        <Typography
          variant="h1"
          gutterBottom
          sx={{ fontWeight: "bold", color: theme.palette.text.primary }}
        >
          {subsection.subsection}
        </Typography>
        <Grid container spacing={3}>
          {content.map((step, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <StepCard>
                <StepDescription>{step}</StepDescription>
                <StepNumberBox>
                  <StepNumber>{`0${index + 1}`}</StepNumber>
                </StepNumberBox>
              </StepCard>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ViewSubsectionSteps;
